import { HeaderComponent } from "./HeaderComponent";

/**
 * Header экрана прохождения Krok.
 */
export class CoreHeader extends HeaderComponent {

    protected override build(): void {

        this.setLeft(

            this.createIconButton(

                "/img/List.png",

                "menu",

                () => {

                    this.events.listClicked();

                }

            )

        );

        this.setCenter(

            this.createLogo()

        );

        this.setRight(

            this.createIconButton(

                "/img/User.png",

                "user",

                () => {

                    this.events.userClicked();

                }

            )

        );

    }

}